/*
 * Curated wish pool for the stargaze minigame.
 *
 * Each line is a small, cozy one-line thought shown briefly when the player taps
 * a shooting star. Rules of the pool (per CLAUDE.md tone of voice):
 *   - Soft, warm, low-stakes. Never sarcastic, never trite.
 *   - No exclamation points (or at most one, sparingly).
 *   - No "you should" — the wishes name a small good thing, they don't prescribe.
 *   - Short enough to read in 2 seconds (≤ ~60 chars).
 *   - In-world where it can be — references to Fernhollow neighbours (Aldermere,
 *     elf caretakers, mushroom houses, the well) earn their keep.
 *
 * This list is read-only at runtime. New entries are welcome; do not remove
 * entries without a content review (CONTENT_CATALOG.md should be updated).
 */

export const WISHES: readonly string[] = [
  'Someone is thinking of you tonight.',
  "Aldermere's window is still lit.",
  'Tomorrow will be warmer.',
  'The kettle is almost ready.',
  'You remembered to water the moss.',
  'A friend is on their way over.',
  'The bread is rising slowly.',
  'There is jam in the cupboard.',
  "Your hat suits you, you know.",
  'The lanterns will keep burning.',
  'A small thing went right today.',
  'The mushroom houses are full of soft snoring.',
  'You are exactly the right size.',
  'The elves left a pressed leaf for you.',
  'The well water is sweet this week.',
  'Somewhere, a cricket is singing for you.',
  'The path home is shorter than you think.',
  'A pinecone tipped over and made a tiny sound.',
  'No one needs anything from you right now.',
  'Mosswick saved you a seat by the fire.',
  'A breeze just untangled itself in the ferns.',
  'You are doing better than you say you are.',
  'The stars do this every night, in case you missed it.',
  'A small fern uncurled in the dark.',
  'The night is gentle and so are you.',
] as const;

/** Pick a wish at random. Deterministic-friendly via the optional rng param. */
export function pickWish(rng: () => number = Math.random): string {
  return WISHES[Math.floor(rng() * WISHES.length)] ?? WISHES[0]!;
}
